import { TResponseActorDetails } from "@/types/projectType";

/**
 * Backend stores actorDetails as an array, but some response types expose it
 * as a single object. This normalizes both shapes to always return the first actor.
 */
export const getPrimaryActorDetails = (
  actorDetails: TResponseActorDetails | TResponseActorDetails[] | undefined,
): TResponseActorDetails | undefined => {
  if (!actorDetails) return undefined;
  return Array.isArray(actorDetails) ? actorDetails[0] : actorDetails;
};
